import { observer } from 'mobx-react';
import * as React from 'react';
import { WrappedField } from '../../../core/forms';
import { injectTSDI } from '../../../core/tsdi';
import { I18nStore } from '../../../core/i18n-store';
import './default-checkbox.scss';

interface DefaultCheckboxProps {
    field: WrappedField<boolean>;
    label?: React.ReactNode;
    disabled?: boolean;
    required?: boolean;
    showOptional?: false;
    contrast?: boolean;
    className?: string;
    'data-role'?: string;
}

export const DefaultCheckbox = observer(function DefaultCheckbox(
    props: DefaultCheckboxProps
) {
    const { translate } = injectTSDI(I18nStore);
    const {
        className = 'field-radio',
        field,
        label,
        required,
        showOptional = !required,
        disabled
    } = props;
    const [randomId] = React.useState(
        () => `${Math.round(Math.random() * 100000)}-checkbox`
    );

    const onChange = () => {
        if (disabled) {
            return;
        }
        field.value = !field.value;
    };
    const contrastClass = `${className}--contrast`;
    const errorClass = `${className}--error`;

    return (
        <fieldset
            className={classnames(className, className, {
                [contrastClass]: props.contrast,
                [errorClass]: field?.error ?? ''
            })}
        >
            <input
                type="checkbox"
                id={randomId}
                required={required}
                checked={field?.value}
                onChange={onChange}
                data-role={props['data-role']}
            />
            <label className="field-radio-label" htmlFor={randomId}>
                {label}
                {showOptional && <i>({translate('commons.optional')})</i>}
            </label>
        </fieldset>
    );
});
